var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center unauthorized"},[_c('h2',[_c('v-icon',{attrs:{"x-large":"","color":"warning"}},[_vm._v("mdi-alert")]),_vm._v("Unauthorized")],1),_c('p',[_vm._v("You do not have permissions or your sign in failed.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }